export default __webpack_public_path__ + "static/media/pink-2.dcace379.png";